import dynamic from "next/dynamic";

import type { Props as DrawerProps } from "scmp-app/components/common/drawer";

export const DynamicDrawer = dynamic<DrawerProps>(() =>
  import("scmp-app/components/common/drawer").then(module => module.Drawer),
);
